import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '@weezevent/nacre';

export default class Wizard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentStep: 0
        };
    }

    currentStep() {
        return this.props.steps[this.state.currentStep];
    }

    hasPrevious() {
        return this.state.currentStep > 0;
    }

    hasNext() {
        return this.state.currentStep < this.props.steps.length - 1;
    }

    renderHeader() {
        if (typeof this.currentStep().name === 'function') {
            return this.currentStep().name();
        }

        return this.currentStep().name;
    }

    renderBody() {
        return this.currentStep().component;
    }

    previousStep() {
        this.setState(({ currentStep }) => ({
            currentStep: currentStep - 1
        }));
    }

    nextStep() {
        if (this.hasNext()) {
            this.setState(({ currentStep }) => ({
                currentStep: currentStep + 1
            }));
        } else {
            this.props.onSubmit();
        }
    }

    shouldRenderPreviousButton() {
        return this.props.canGoBack;
    }

    renderPreviousButton() {
        if (!this.shouldRenderPreviousButton()) {
            return null;
        }

        return (
            <Button disabled={!this.hasPrevious()} onClick={this.previousStep.bind(this)}>
                Previous
            </Button>
        );
    }

    nextLabel() {
        if (this.currentStep().next) {
            return this.currentStep().next;
        }

        return this.hasNext() ? <Trans i18nKey="ticket.common.action.next">Next</Trans> : <Trans i18nKey="ticket.common.action.save">Save</Trans>;
    }

    renderNextOrSubmitButton() {
        if (this.currentStep().hasNext === false) {
            // defaults to true if no set
            return null;
        }

        return (
            <Button primary fluid onClick={this.nextStep.bind(this)}>
                {this.nextLabel()}
            </Button>
        );
    }

    renderFooter() {
        if (!this.props.showFooter) {
            return null;
        }

        return (
            <div className={`wizard-footer ${this.shouldRenderPreviousButton() ? '' : 'alone'}`}>
                {this.renderPreviousButton()}
                {this.renderNextOrSubmitButton()}
            </div>
        );
    }

    render() {
        return (
            <div className="wizard">
                <div className="wizard-header">{this.renderHeader()}</div>
                <div className="wizard-body">{this.renderBody()}</div>
                {this.renderFooter()}
            </div>
        );
    }
}

Wizard.defaultProps = {
    showFooter: true,
    canGoBack: true
};

Wizard.propTypes = {
    canGoBack: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
    showFooter: PropTypes.bool,
    steps: PropTypes.arrayOf(
        PropTypes.shape({
            component: PropTypes.element.isRequired,
            hasNext: PropTypes.boolean,
            name: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.node]).isRequired,
            next: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
        })
    ).isRequired
};
